<template>
  <el-container class="ServiceForm">
    <el-main class="p-0">
      <el-form
        ref="form"
        class="form-label-80"
        label-width="80px"
        :model="data"
        :rules="rules"
        inline
      >
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('lang.receipt_date')" prop="request_date">
              <ADatePicker
                v-model="data.request_date"
                :placeholder="$t('message.choose_date')"
                :clearable="false"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('lang.access_date')" prop="service_date">
              <ADatePicker
                v-model="data.service_date"
                :placeholder="$t('message.choose_date')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="설치일" prop="install_date">
              <el-input v-model="data.install_date" maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="담당자" prop="charger">
              <el-input v-model="data.charger" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="거래처" prop="customer_name">
              <el-input v-model="data.customer_name" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('lang.user_tel')" prop="customer_tel">
              <el-input v-model="data.customer_tel" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('lang.user_tel') + 2" prop="customer_tel2">
              <el-input v-model="data.customer_tel2" />
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="무상여부">
              <ACheckboxYN v-model="data.free_flag" prop="free_flag" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="우편번호" prop="customer_zipcode">
              <el-input
                v-model="data.customer_zipcode"
                class="zipcode readonly"
                readonly
              />
              &nbsp;
              <el-button @click="popupZipcode(handleCompletedSearchZipcode)"
                >우편번호검색</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="17">
            <el-form-item :label="$t('lang.address')" prop="customer_addr">
              <el-input
                ref="customer_addr"
                v-model="data.customer_addr"
                maxlength="100"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('lang.fault_symptom')" prop="symptom">
              <el-input
                v-model="data.symptom"
                type="textarea"
                :rows="2"
                maxlength="100"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="비고" prop="desc">
              <el-input
                v-model="data.desc"
                type="textarea"
                :rows="2"
                maxlength="100"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        :disabled="!has_grant_write"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{
          is_new ? $t("button.register") : $t("button.modify")
        }}(F4)</el-button
      >
      <el-button
        type="danger"
        v-show="!is_new"
        :disabled="!has_grant_write"
        @click="handleClickDelete"
        >{{ $t("button.delete") }}</el-button
      >
      <!-- <el-button class="close-button" @click="closeDialog">{{ $t("button.close") }}(Esc)</el-button> -->
    </el-footer>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import { form } from "@/common/mixins/form";
import { zipcode_search } from "@/common/mixins/zipcode_search";

export default {
  name: "ServiceForm",
  mixins: [form, zipcode_search],
  data() {
    return {
      rules: {
        request_date: [
          { required: true, message: this.$t("message.choose_date") },
        ],
        service_date: [{ required: true, message: "방문일을 입력해 주세요." }],
        customer_name: [
          {
            required: true,
            message: "거래처를 입력해 주세요.",
            trigger: "change",
          },
        ],
        customer_zipcode: [
          {
            required: true,
            message: "우편번호를 입력해 주세요.",
            trigger: "change",
          },
        ],
        customer_addr: [
          {
            required: true,
            message: "주소를 입력해 주세요.",
            trigger: "change",
          },
        ],
        symptom: [
          {
            required: true,
            message: this.$t("message.please_enter_the_fault_details"),
            trigger: "blur",
          },
        ],
      },
      title: "A/S",
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          id: 0,
          request_date: this.util.getDate(),
          service_date: null,
          install_date: null,
          charger: "",
          customer_zipcode: "",
          customer_addr: "",
          customer_charger: "",
          customer_tel: "",
          customer_tel2: "",
          free_flag: "N",
          symptom: "",
        };
      },
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  beforeDestroy() {
    this.$emit("closed", this.data);
  },
  computed: {
    ...mapGetters(["userId", "userName"]),
    is_new() {
      return this.data.id < 1;
    },
  },
  methods: {
    doRegister() {
      let data = Object.assign({}, this.data);
      if (!data.customer_name) {
        data.customer_name = data.customer_charger;
      }
      if (this.is_new) {
        this.api.createService(data).then((res) => {
          this.handleReponseCompleted(res, this.$t("message.success_create"));
        });
      } else {
        this.api.updateService(data).then((res) => {
          this.handleReponseCompleted(res, this.$t("message.success_update"));
        });
      }
    },
    doDelete() {
      this.api.deleteService(this.data).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.handleReponseCompleted(res, this.$t("message.success_delete"));
      });
    },
    handleCompletedSearchZipcode(zipcode, addr) {
      this.data.customer_zipcode = zipcode;
      this.data.customer_addr = addr + " ";
      this.$refs.customer_addr.focus();
    },
    handleClickRegister() {
      if (!this.has_grant_write) return;

      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.is_new && this.util.isPastDate(this.data.request_date)) {
          this.util.confirm(
            this,
            this.title,
            "접수일이 오늘보다 늦습니다. 계속 등록하시겠습니까?",
            this.doRegister
          );
          return;
        }
        this.doRegister();
      });
    },
    handleClickDelete() {
      this.util.confirm_delete(this, this.title, this.doDelete);
    },
    handleReponseCompleted(res, message) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, message);
      this.$emit("completed", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.zipcode {
  width: 80px;
}
</style>
